import {getCurrentUser, UserModel} from '../../store/reducers/user/user.reducer';
import {Stack} from "@mui/material";

import BgImage from "../../assets/background.jpg";
import Thumbnail from "../../components/thumbnail/thumbnail.component";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import * as React from "react";
import Typography from "@mui/material/Typography";
import {useSelector} from "react-redux";
import {useEffect} from "react";

interface ComponentProps {
  user: UserModel;
}

export default function Home()
{
  const currentUser: UserModel = useSelector(getCurrentUser);

  useEffect(() => {
    test();
  }, []);

  const test = async () =>
  {

  }

  return (<div>
    <Typography variant='h3'>Üdvözöllek, {currentUser.name}!</Typography>
    <br/>
    <Typography variant='h4'>Oldalválasztó</Typography>
    <br />
    <Stack flexDirection={"row"} flexWrap={"wrap"} justifyContent={"flex-start"} alignItems={"flex-start"}>
      <Thumbnail title={"Események"} url={"/esemenyek"} bgImage={BgImage} icon={<ScatterPlotIcon/>} />
      <Thumbnail title={"Posztok"} url={"/posztok"} bgImage={BgImage} icon={<ScatterPlotIcon/>} />
      <Thumbnail title={"Üzenetek"} url={"/uzenetek"} bgImage={BgImage} icon={<ScatterPlotIcon/>}  />
      <Thumbnail title={"Hírlevél"} url={"/hirlevel"} bgImage={BgImage} icon={<ScatterPlotIcon/>}  />
      <Thumbnail title={"Beállítások"} url={"/beallitasok"} bgImage={BgImage} icon={<ScatterPlotIcon/>}  />
    </Stack>
  </div>)
}